/**
=========================================================
* Otis Admin PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Otis Admin PRO React components

// Otis Admin PRO React context
import { useMaterialUIController, setLayout } from "context";
import { IconButton } from "@mui/material";
import  NavOpen from "assets/images/icons/nav_open.svg";
import  NavClose from "assets/images/icons/nav_close.svg";
import { setMiniSidenav } from "context";

const MDBox = require("components/MDBox").default;

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav,mobileView } = controller;
  const { pathname } = useLocation();
    controller;
  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: mobileView?1:3,
        position: "relative", 

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(300),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      <IconButton
            // sx={navbarDesktopMenu}
            onClick={() => setMiniSidenav(dispatch, !miniSidenav)}
            size="small"
            disableRipple
            style={{
              position: "fixed",
              top: "110px",
              left: miniSidenav ? "-10px" : "275px",
              backgroundColor: "#F0F2F5",
              zIndex: 1000,
              transition: "all 0.3s",
              width: "33px",
              height: "33px",
            }}
          >
            <img src={miniSidenav ? NavClose : NavOpen} alt="nav" />
            
          </IconButton>
      {children}
    </MDBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
